// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { GetNotificationCountsApiNotificationsCountsGetData, GetNotificationCountsApiNotificationsCountsGetResponses, HealthzHealthzGetData, HealthzHealthzGetResponses, ListNotificationsApiNotificationsGetData, ListNotificationsApiNotificationsGetErrors, ListNotificationsApiNotificationsGetResponses, PatchAllNotificationsApiNotificationsPatchData, PatchAllNotificationsApiNotificationsPatchErrors, PatchAllNotificationsApiNotificationsPatchResponses, PatchNotificationApiNotificationsNotificationIdPatchData, PatchNotificationApiNotificationsNotificationIdPatchErrors, PatchNotificationApiNotificationsNotificationIdPatchResponses, ReadyzReadyzGetData, ReadyzReadyzGetResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Notifications
 */
export const listNotificationsApiNotificationsGet = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsApiNotificationsGetData, ThrowOnError>): RequestResult<ListNotificationsApiNotificationsGetResponses, ListNotificationsApiNotificationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListNotificationsApiNotificationsGetResponses, ListNotificationsApiNotificationsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications',
    ...options
});

/**
 * Patch All Notifications
 */
export const patchAllNotificationsApiNotificationsPatch = <ThrowOnError extends boolean = false>(options: Options<PatchAllNotificationsApiNotificationsPatchData, ThrowOnError>): RequestResult<PatchAllNotificationsApiNotificationsPatchResponses, PatchAllNotificationsApiNotificationsPatchErrors, ThrowOnError> => (options.client ?? client).patch<PatchAllNotificationsApiNotificationsPatchResponses, PatchAllNotificationsApiNotificationsPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Notification Counts
 */
export const getNotificationCountsApiNotificationsCountsGet = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationCountsApiNotificationsCountsGetData, ThrowOnError>): RequestResult<GetNotificationCountsApiNotificationsCountsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationCountsApiNotificationsCountsGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications/counts',
    ...options
});

/**
 * Patch Notification
 */
export const patchNotificationApiNotificationsNotificationIdPatch = <ThrowOnError extends boolean = false>(options: Options<PatchNotificationApiNotificationsNotificationIdPatchData, ThrowOnError>): RequestResult<PatchNotificationApiNotificationsNotificationIdPatchResponses, PatchNotificationApiNotificationsNotificationIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<PatchNotificationApiNotificationsNotificationIdPatchResponses, PatchNotificationApiNotificationsNotificationIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications/{notification_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Healthz
 *
 * Liveness probe: 200 as long as the process is responsive.
 */
export const healthzHealthzGet = <ThrowOnError extends boolean = false>(options?: Options<HealthzHealthzGetData, ThrowOnError>): RequestResult<HealthzHealthzGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthzHealthzGetResponses, unknown, ThrowOnError>({ url: '/healthz', ...options });

/**
 * Readyz
 *
 * Readiness probe: 200 if the DB pool can serve a SELECT 1; 503 otherwise.
 */
export const readyzReadyzGet = <ThrowOnError extends boolean = false>(options?: Options<ReadyzReadyzGetData, ThrowOnError>): RequestResult<ReadyzReadyzGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadyzReadyzGetResponses, unknown, ThrowOnError>({ url: '/readyz', ...options });
